import React from 'react'
import { ErrorMessage } from 'app/types'
import { logger } from 'helpers/logger'

export function NotFound(props) {
    logger.error('Page not found', props.match)

    return <h3 className="error-message">{ErrorMessage.PageNotFound}</h3>
}
